var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMinhasMatriculas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "701A1B7D-0318-47B5-91B5-AC1D85BC1B0C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.home-aba/concursos",
    transform: "translate(-24.000000, -289.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-minhas-matriculas",
    transform: "translate(0.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,16 C20.5522847,16 21,16.4477153 21,17 C21,17.5128358 20.6139598,17.9355072 20.1166211,17.9932723 L20,18 L6.5,18 C5.72030388,18 5.07955132,18.5948881 5.00686658,19.35554 L5,19.5 C5,20.0522847 4.55228475,20.5 4,20.5 C3.44771525,20.5 3,20.0522847 3,19.5 C3,17.6314366 4.4642776,16.1048736 6.3079648,16.0051789 L6.5,16 L20,16 Z",
    id: "Path",
    fill: "#1717CE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,1 L6.5,1 C4.56700338,1 3,2.56700338 3,4.5 L3,19.5 C3,21.4329966 4.56700338,23 6.5,23 L20,23 C20.5522847,23 21,22.5522847 21,22 L21,2 C21,1.44771525 20.5522847,1 20,1 Z M19,3 L19,21 L6.5,21 C5.67157288,21 5,20.3284271 5,19.5 L5,4.5 L5.00686658,4.35553999 C5.07955132,3.59488808 5.72030388,3 6.5,3 L19,3 Z",
    id: "Path",
    fill: "#1717CE",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinhasMatriculas);
export default __webpack_public_path__ + "static/media/ic-minhas-matriculas.7e6913d33a20bb193c7be018d6dbfe76.svg";
export { ForwardRef as ReactComponent };